<template>
    <eqt-table @refresh="refresh" :total="total" :loading="loading" :title="$t('Pages.SupportTickets.title')" :subtitle="$t('Common.table_subtitle')" :items="items" :headers="headers" :hideEditBtn="true" :hideDeleteBtn="true" >
        <template slot="items" slot-scope="{ item }">
            <td>{{ item.id }}</td>
            <td>{{ item.name}}</td>
            <td>{{ item.company_name}}</td>
            <td>{{ item.address}}</td>
            <td>{{ item.municipality}}</td>
            <td>{{ item.city}}</td>
            <td>{{ item.phone}}</td>
            <td>{{ item.email}}</td>
            <td>{{ item.language}}</td>
            <td>{{ item.content}}</td>
            <td class="text-xs-center"><v-icon v-if="item.read === 0">check_box_outline_blank</v-icon><v-icon v-else>check_box</v-icon></td>
        </template>
        <template slot="action-items" slot-scope="{ item }">
            <v-tooltip top>
                <v-btn slot="activator" class="mx-0" small flat icon color="primary" @click="markAsRead(item)">
                    <v-icon small>markunread</v-icon>
                </v-btn>
                <span>{{$t('Core.Fields.mark_as_read')}}</span>
            </v-tooltip>
        </template>
    </eqt-table>
</template>

<script>
    import i18n from '@/i18n'
    import EqtTable from '../../components/core/Table'
    export default {
        name: "supporttickets-table",
        components: {EqtTable},
        props: {
            items: {
              type: Array,
              required: true
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                required: true
            },
            hideActions: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            headers: [
                {
                    sortable: true,
                    text: '#',
                    value: 'id'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.SupportTickets.model.name'),
                    value: 'name'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.SupportTickets.model.company_name'),
                    value: 'company_name'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.SupportTickets.model.address'),
                    value: 'address'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.SupportTickets.model.municipality'),
                    value: 'address'
                },
                {
                    sortable: true,
                    text: i18n.t('Pages.SupportTickets.model.city'),
                    value: 'address'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.SupportTickets.model.phone'),
                    value: 'phone'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.SupportTickets.model.email'),
                    value: 'phone'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.SupportTickets.model.language'),
                    value: 'language'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.SupportTickets.model.content'),
                    value: 'content'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.SupportTickets.model.read'),
                    value: 'read',
                    align: 'center'
                },
            ],
        }),
        computed:{

        },
        methods: {
            refresh(data){
                this.$emit('refresh', data);
            },
            markAsRead(item){
                this.repositories.supportTicket.update(item.id, '').then(response => {
                    this.$toast.info(response.data.message);
                    this.refresh(response.data)
                })
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>